// config/agents.js
// ----------------
// Static configuration for every AI agent type the chat widget can use.
//
// Each key is the "agentkey" string that the backend also knows about.
// Fields:
//   name          – Human-readable label shown in the UI
//   emoji         – Icon shown next to the agent name
//   color         – Tailwind classes for the agent card's background & text
//   description   – Short blurb shown on the agent-selector screen
//   isbot         – true  → the agent is a built-in bot (no file selection needed)
//                   false → the agent needs the user to pick source files first
//   sourcerequired – if true, the chat input is disabled until files are selected

const agents = {
  idokschat_agent: {
    name: 'Document Finder',
    emoji: '🕵️‍♂️',
    color: 'bg-blue-100 text-blue-800',
    description: 'Quickly search and retrieve information from the selected files using smart search',
    isbot: true,
  },
  idoks_agent: {
    name: 'AI Assistant',
    emoji: '🕵️‍♂️',
    color: 'bg-green-100 text-green-800',
    description: 'Find the information you need, instantly.',
    isbot: true,
  },
  knowledgebase_agent: {
    name: 'AI Assistant',
    emoji: '🕵️‍♂️',
    color: 'bg-green-100 text-green-800',
    description: 'Find the information you need, instantly.',
    isbot: true,
  },
  search_agent: {
    name: 'File Q&A Agent',
    emoji: '🕵️‍♂️',
    color: 'bg-blue-300 text-blue-800 hover:bg-blue-400',
    description: 'Ask questions and get answers from the content of your selected files',
    sourcerequired: true,
    isbot: false,
  },
  summarizer_agent: {
    name: 'Summarizer Agent',
    emoji: '✍️',
    color: 'bg-green-300 text-green-800 hover:bg-green-400',
    description: 'Summarize content into short notes',
    sourcerequired: true,
    isbot: false,
  },
  questionpaper_agent: {
    name: 'Question Paper Agent',
    emoji: '📄',
    color: 'bg-purple-300 text-purple-800 hover:bg-purple-400',
    description: 'Generate quizzes or exam papers',
    sourcerequired: true,
    isbot: false,
  },
  kiwiedtech_starprogram_agent: {
    name: 'AI Assistant',
    emoji: '🕵️‍♂️',
    color: 'bg-green-100 text-green-800',
    description: 'Find the information of student, instantly.',
    isbot: true,
  },
  custom_agent: {
    name: 'AI Assistant',
    emoji: '🤖',
    color: 'bg-indigo-100 text-indigo-800',
    description: 'Custom AI assistant powered by your knowledge base.',
    isbot: true,
  },
};

export default agents;
